import { WpOptions } from '@/utils/functions/wordpress/fetch-options';

const fetchWordpressOptions = async (): Promise<WpOptions> => {
    const options = (await fetch(`/api/wp/options`, {})).json();

    return options as unknown as Promise<WpOptions>;
};

export default fetchWordpressOptions;
